import { render, staticRenderFns } from "./cameramodal.component.html?vue&type=template&id=8b2977c2&scoped=true&"
import script from "./cameramodal.component.ts?vue&type=script&lang=ts&"
export * from "./cameramodal.component.ts?vue&type=script&lang=ts&"
import style0 from "./cameramodal.component.scss?vue&type=style&index=0&id=8b2977c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2977c2",
  null
  
)

export default component.exports